/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Container,
  InputAdornment,
  Link,
  TextField,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  makeStyles,
  Typography,
  Autocomplete,
  Alert,
  MenuItem
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PostAddIcon from '@material-ui/icons/PostAdd';
import SearchIcon from '../../../icons/Search';
import PropTypes from 'prop-types';
import commonService from '../../../services/commonService';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const SelectProduct = (props) => {
  const { selectProduct, createNew, formSubmitFlag } = props;
  const [value, setValue] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);

  const intervalId = useRef(null);

  const search = (key) => {
    setIsLoading(true);
    commonService.getProductByKey(key).then((response) => {
      if (response) {
        setResults(response);
      }
      setIsLoading(false);
    });
  };

  const classes = useStyles();
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: 'create',
    title: '',
  });

  const closeModal = () => setModalState({
    ...modalState,
    isOpen: false,
  });

  const onClikNewItem = () => {
    createNew(value);
    setValue(value);
  };

  useEffect(() => {
    if (intervalId.current) {
      clearTimeout(intervalId.current);
    }
    intervalId.current = setTimeout(() => {
      if (value.length > 1) {
        search(value);
      }
    }, 250);
  }, [value]);

  useEffect(() => {
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!formSubmitFlag) {
      setValue('');
    }
  }, [formSubmitFlag]);

  return (
    <Box sx={{ pt: 3 }}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={1}
          style={{ marginTop: '20px' }}
        >
          <Grid
            xs={8}
            sm={10}
            sx={{
              display: 'flex',
              flexFlow: 'row nowrap',
              alignItems: 'center',
              gap: 3,
              justifyContent: 'center'
            }}
            style={{ paddingRight: '10px' }}
            className="tp-oc-search-wrapper"
          >
            <Autocomplete
              value={selectedProduct}
              onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                  setSelectedProduct({ name: newValue });
                } else {
                  selectProduct(results, newValue);
                  setSelectedProduct(newValue);
                }
              }}
              options={results}
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                  return option;
                }
                // Regular option
                return option.name;
              }}
              loading={isLoading}
              loadingText="Yükleniyor.."
              inputValue={value}
              filterOptions={(opt, { inputValue }) => {
                if (!isLoading && value && opt.length === 0) {
                  setResults([{
                    id: inputValue,
                    name: inputValue,
                    isNew: true,
                  }]);
                }
                return opt;
              }}
              onInputChange={(event) => {
                if (!event) {
                  setValue(selectedProduct?.name);
                  return;
                }
                setValue(event.target.value);
              }}
              renderOption={(p, option) => (
                <MenuItem
                  {...p}
                  onClick={!option.isNew ? p.onClick : onClikNewItem}
                >
                  {!option.isNew && option.name}
                  {option.isNew && option.name && (
                    <Box sx={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
                      <PostAddIcon />
                      <Typography>
                        <Link>{option.name}</Link>
                        {' '}
                        adında yeni bir ürün eklemek için tıklayın
                      </Typography>
                    </Box>
                  )}
                </MenuItem>
              )}
              noOptionsText={isLoading ? '...' : (!value ? 'Ürün aramak için yazmaya başlayın' : 'Aradığınız Ürün bulunamadı')}
              autoComplete
              includeInputInList
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className="tp-adornment__custom"
                  style={{ minWidth: '200px' }}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    )
                  }}
                  placeholder="Ürün, Hizmet, Kategori ara..."
                />
              )}
              fullWidth
            />
            <Alert
              severity="error"
              className="tp-oc-alert"
            >
              Lütfen aradığınız ürün veya hizmetin genel adını yazınız.
              {' '}
              <strong>Örneğin;</strong>
              {' '}
              Ucf 208 Rulman için ihale açacaksanız, arama çubuguna sadece
              {' '}
              <strong>RULMAN</strong>
              {' '}
              yazın. Detayları aşağıda açılan kutucuklara yazmalısınız.
            </Alert>
          </Grid>
          <Grid
            xs={4}
            sm={2}
            sx={{
              display: 'flex',
              flexFlow: 'row nowrap',
              alignItems: 'center',
              gap: 3,
              justifyContent: 'center'
            }}
          >
            <Tooltip
              title="Yeni İhale Nasıl Açılır?"
              className="tp-new-order-modal"
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setModalState({
                    isOpen: true
                  });
                }}
                type="button"
                color="secondary"
                className="tp-btn__how-to-open-bid tp-btn-yellow-dark"
                startIcon={<LiveHelpIcon />}
                size="large"
                sx={{
                  whiteSpace: 'nowrap'
                }}
                style={{ minWidth: '200px' }}
              >
                Yeni İhale Nasıl Açılır?
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
        <Dialog
          onClose={closeModal}
          aria-labelledby="customized-dialog-title"
          open={modalState.isOpen}
          className="tp-how-new-order__modal"
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={closeModal}
          >
            <b>Yeni İhale Nasıl Açılır?</b>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={closeModal}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography>
              <p>
                <strong>
                  Ürün ve Hizmet Detayı:
                </strong>
                Ürün ve hizmet detayı kısmına fiyat almak istediğiniz ürün veya hizmetin adı, türü, modeli, rengi, ölçüsü vb. özelliklerini yazabilirsiniz. Burada dikkat edilmesi gereken her ürün için ayrı satır oluşturulması gerektiğidir. Aşağıda örnekle daha detaylı izah edilecektir.
              </p>
              <p>
                Marka, miktar gibi hususları kendi hücrelerine yazmaya özen göstermelisiniz.
              </p>
              <p>
                <strong>
                  Örneğin;
                </strong>
                100 adet UCF 208 Yataklı Rulman ve 50 adet UCF 206 Yataklı Rulman alacaksınız diyelim.
              </p>
              <p>
                İki üründe rulman ancak farklı rulman çeşitli olduğundan her ürün için ayrı satır açılması gereklidir.
              </p>
              <p>
                İki ürünü de aynı satırda belirterek ihale (talep) açıldığında tedarikçilerin sağlıklı teklif verebilme olasılığı ortadan kalkmaktadır. Sağlıklı bir ihale yapılması mümkün olmayacaktır.
              </p>
              <p>
                <strong>
                  Satır 1 :
                </strong>
                “UCF 208 Yataklı Rulman fiyat teklifi almak istiyorum” varsa diğer açıklamalarınızı da yazabilirsiniz.
              </p>
              <p>
                <strong>
                  Satır 2 :
                </strong>
                “UCF 206 Yataklı Rulman fiyat teklifi almak istiyorum, Çin malı rulman teklifi vermeyin” gibi de açıklama yapabilirsiniz.
              </p>
              <ul>
                <li>
                  <strong>
                    Marka:
                  </strong>
                  İhale oluştururken Marka bildirmek zorunda değilsiniz. Ancak almak istediğiniz belli bir marka veya markalar var ise mutlaka marka hücresine yazınız.
                </li>
                <li>
                  <strong>
                    Miktar:
                  </strong>
                  Ne kadar ürün almak istiyorsanız onu yazıp ölçü birimini belirlemelisiniz.
                </li>
                <li>
                  <strong>
                    Ödeme Türü:
                  </strong>
                  İhale açarken almak istediğiniz ürünün bedelini ne şekilde ödemek istediğinizi belirtiniz ki tedarikçi firmalar fiyatlarını ona göre versinler.
                </li>
                <li>
                  <strong>
                    Termin Süresi:
                  </strong>
                  Satın almak istediğiniz ürünün ne kadar süre içerisinde sizde olmasını istediğiniz süredir.
                </li>
                <li>
                  <strong>
                    İhale Süresi:
                  </strong>
                  Açmış olduğunuz ihalenin sistemde kalacağı süredir.
                </li>
                <li>
                  <strong>
                    Açılan ihalede adımı gizle:
                  </strong>
                </li>
              </ul>
              <p>
                Bu seçeneği kullanarak ihale açtığınızda, ihalede Firma Adınız gizlenir. Teklif verecek firmalar adınızı GİZLİ FİRMA olarak görürler. İhaleyi sonuçlandırdığınızda ihaleyi kazanan firma adınızı görebilecektir.
              </p>
              <ul>
                <li>
                  <strong>
                    Fiyat teklifi almak istediğiniz Favori Firmaları ya da Grupları seçiniz:
                  </strong>
                </li>
              </ul>
              <p>
                Bu seçeneği kullanarak açtığınız ihaleyi yalnızca seçtiğiniz Favori Firmalar ya da Favori Gruplarda yer alan firmalar görebilir ve teklif verebilir.
                <a
                  href="https://joobid.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://Joobid.com
                </a>
                ihaleniz ile ilgili seçmiş olduğunuz tedarikçi firmaların tümüne otomatik olarak bilgilendirme maili gönderir.
              </p>
              <ul>
                <li>
                  <strong>
                    Açılan ihalede adımı gizle
                  </strong>
                </li>
              </ul>
              <p>
                Bu seçeneği kullanarak ihale açtığınızda, ihalede Firma Adınız gizlenir. Teklif verecek firmalar adınızı göremezler**.** İhaleyi sonuçlandırdığınızda ihaleyi kazanan firma adınızı görebilecektir.
              </p>
              <ul>
                <li>
                  <strong>
                    Bu ihaleyi ileri tarihte başlat
                  </strong>
                </li>
              </ul>
              <p>
                İleri bir tarihte aktif olacak bir ihale oluşturmak istiyorsanız bu sekmeyi kullanabilirsiniz. İleri tarihe planladığınız ihaleniz seçtiğiniz tarihte görünür olacaktır.
              </p>
              <ul>
                <li>
                  <strong>
                    İhale grubu
                  </strong>
                </li>
              </ul>
              <p>
                Daha sonraki zamanlarda belirli bir projeye özel açmış olduğunuz ihaleleri görüntülemek ya da filtrelemek isterseniz bu seçeneği kullanabilirsiniz.
              </p>
              <p>
                <strong>
                  Örnek
                </strong>
                : X projeniz için alım ihaleleri açacaksınız. Bu projeye ait ihalelerinizi açarken X ihale grubu oluşturup sonrasında ihaleleri açarken bu grubu seçerseniz. İleri ki tarihlerde İhale grupları adına göre açmış olduğunuz ihaleleri listeleyebilirsiniz. Örneğin X projesi için hangi ürünler için ihale açıp satın alma yaptığınızı bu sekme sayesinde mümkün olacaktır
              </p>
              <p>
                <strong>
                  İhale Aç:
                </strong>
                Hücreleri doldurduktan sonra
                <strong>
                  "İhale Aç (Oluştur)"
                </strong>
                butonuna tıklayarak yeni ihale açma sürecini tamamlayabilirsiniz.
              </p>
            </Typography>
          </DialogContent>
        </Dialog>
      </Container>
    </Box>
  );
};

export default SelectProduct;

SelectProduct.propTypes = {
  selectProduct: PropTypes.func.isRequired,
  createNew: PropTypes.func.isRequired,
  formSubmitFlag: PropTypes.any,
};
